export const TOKEN_API_URL = '/api/eos/Common/GetOtelTrace';

export const EOS_USER_API_URLS = {
  USER_SELF: '/api/eos/User/Self',
  USER_LIST: '/api/eos/User/UserDetails',
  ADD_UPDATE_USER_ROLES: '/api/eos/User/AddOrUpdateUserRoles',
};

export const EOS_API_URLS = {
  PORTFOLIO: '/api/eos/Common/GetPortfolio',
  MARKET_WITH_SUPPLY_CONTRACT: '/api/eos/Common/GetMarketWithSupplyContract',
  FORECAST_FILE_NAME: '/api/eos/Common/GetForecastFileName',
  REPORT_TYPES_FOR_SUPPLY_CONTRACT: '/api/eos/Common/GetReportTypesForSupplyContract',
  GET_FORECAST_RISK_PROFILES: '/api/eos/Common/GetForecastRiskProfiles',
};

export const FORECAST_API_URLS = {
  DATA: '/api/eos/Forecast/GetForecastData',
  UPDATE_RISK_HAIRCUT_DATA: '/api/eos/Forecast/SaveRiskAdjustedData',
  RESET_HAIRCUT_DATA: '/api/eos/Forecast/ResetHaircutRiskProfile',
  RESET_FISCALITY_DATA: '/api/eos/Forecast/ResetFiscalityRiskProfile',
  LATEST_UPLOADED: '/api/eos/Forecast/GetLatestUploadedForecast',
};

export const SCENARIO_ANALYSIS_API_URLS = {
  DATA: '/api/eos/ScenarioAnalysis/GetScenarioAnalysisData',
  PREFERENCES_SAVE: '/api/eos/ScenarioAnalysis/SaveReportPreferences',
  PREFERENCES_GET: '/api/eos/ScenarioAnalysis/GetReportPreferences',
};

export const AUDIT_API_URLS = {
  LOG_DATA: '/api/eos/Audit/GetAuditLog',
  GET_AUDIT_DETAIL: '/api/eos/Audit/GetAuditLogDetails',
  SAVE_AUDIT_LOG_DATA: '/api/eos/Forecast/UploadForecast',
};

const FORECAST_UPLOAD_APPROVAL_STATUS_URL = '/api/eos/Workflow/ForecastUploadApprovalStatus';

export const FORECAST_WORKFLOW_API_URLS = {
  SEND_FOR_APPROVAL: FORECAST_UPLOAD_APPROVAL_STATUS_URL,
  APPROVE: FORECAST_UPLOAD_APPROVAL_STATUS_URL,
  REJECT: FORECAST_UPLOAD_APPROVAL_STATUS_URL,
  APPROVAL_STATUS: FORECAST_UPLOAD_APPROVAL_STATUS_URL,
};

export const ROYALTIES_API_URLS = {
  GET_IN_KIND_FISCALITY: '/api/eos/Royalties/GetInKindFiscality',
  GET_MAZARA_FLOWS: '/api/eos/Royalties/GetMazaraFlows',
  GET_MAZARA_OSS_DATA: '/api/eos/Royalties/GetMazaraOssData',
  GET_MAZARA_VS_OSS: '/api/eos/Royalties/GetMazaraVsOss',
};

export const RANKING_API_URLS = {
  GET_RANKING: '/api/eos/Ranking/GetRanking',
};

export const INTERTEK_API_URLS = {
  GET_FIELD_ALLOCATION: '/api/eos/Intertek/GetFieldAllocation',
  GET_SUPPLIER_BUYER_PROFILE: '/api/eos/Intertek/GetSupplierBuyerProfile',
};

export const ALLOCATION_API_URLS = {
  GET_ALLOCATION: '/api/eos/Allocation/GetAllocation',
  GET_DELIVERY_POINT: '/api/eos/Allocation/GetDeliveryPoint',
  DOWNLOAD_ALLOCATION: '/api/eos/Allocation/DownloadAllocation',
  UPLOAD_ALLOCATION: '/api/eos/Allocation/UploadAllocation',
  GET_ALLOCATION_AUDIT_LOG: '/api/eos/Allocation/GetAllocationAuditLog',
  GET_ALLOCATION_AUDIT_LOG_DETAILS: '/api/eos/Allocation/GetAllocationAuditLogDetails',
};

export const MAPPING_API_URLS = {
  GET_MARKET_MAPPINGS: '/api/eos/MappingSheet/GetMarketMapping',
  GET_SUPPLY_CONTRACT_MAPPINGS: '/api/eos/MappingSheet/GetSupplyContractMapping',
  GET_DELIVERY_POINT_MAPPINGS: '/api/eos/MappingSheet/GetDeliveryPointMapping',
  GET_FIELD_MAPPINGS: '/api/eos/MappingSheet/GetFieldMapping',
  GET_ENDURE_MAPPINGS: '/api/eos/MappingSheet/GetEndurMapping',
  // POST (create or update — same endpoint for both add and edit)
  UPDATE_MARKET_MAPPING: '/api/eos/MappingSheet/UpdateMarketMapping',
  ADD_UPDATE_SUPPLY_CONTRACT_MAPPING: '/api/eos/MappingSheet/AddOrUpdateSupplyContractMapping',
  ADD_UPDATE_DELIVERY_POINT_MAPPING: '/api/eos/MappingSheet/AddOrUpdateDeliveryPointMapping',
  ADD_UPDATE_FIELD_MAPPING: '/api/eos/MappingSheet/AddOrUpdateFieldMapping',
  ADD_UPDATE_ENDURE_MAPPING: '/api/eos/MappingSheet/AddOrUpdateEndurMapping',
  // DELETE (delivery_point, field, endure_mapping only)
  DELETE_DELIVERY_POINT_MAPPING: '/api/eos/MappingSheet/DeleteDeliveryPointMapping',
  DELETE_FIELD_MAPPING: '/api/eos/MappingSheet/DeleteFieldMapping',
  DELETE_ENDURE_MAPPING: '/api/eos/MappingSheet/DeleteEndurMapping',

  // FETCH options for dropdowns in mapping forms
  GET_SUPPLY_CONTRACT_OPTIONS: '/api/eos/MappingSheet/GetSupplyContractList',
  GET_DELIVERY_POINT_OPTIONS: '/api/eos/MappingSheet/GetDeliveryPointList',
  GET_FIELD_OPTIONS: '/api/eos/MappingSheet/GetFieldList',

  SAVE_RISK_PROFILE: '/api/eos/MappingSheet/SaveRiskProfile',
  SET_DEFAULT_RISK_PROFILE: '/api/eos/MappingSheet/SetDefaultRiskProfile',
};

export const API_URLS = {
  EOS_TOKEN: TOKEN_API_URL,
  EOS_USER_SELF: EOS_USER_API_URLS.USER_SELF,
  EOS_USER_LIST: EOS_USER_API_URLS.USER_LIST,
  EOS_ADD_UPDATE_USER_ROLES: EOS_USER_API_URLS.ADD_UPDATE_USER_ROLES,
  EOS_PORTFOLIO: EOS_API_URLS.PORTFOLIO,
  EOS_MARKET_WITH_SUPPLY_CONTRACT: EOS_API_URLS.MARKET_WITH_SUPPLY_CONTRACT,
  EOS_FORECAST_FILE_NAME: EOS_API_URLS.FORECAST_FILE_NAME,
  EOS_REPORT_TYPES_FOR_SUPPLY_CONTRACT: EOS_API_URLS.REPORT_TYPES_FOR_SUPPLY_CONTRACT,
  EOS_GET_FORECAST_RISK_PROFILES: EOS_API_URLS.GET_FORECAST_RISK_PROFILES,
  FORECAST_DATA: FORECAST_API_URLS.DATA,
  UPDATE_FORECAST_RISK_HAIRCUT_DATA: FORECAST_API_URLS.UPDATE_RISK_HAIRCUT_DATA,
  FORECAST_RESET_HAIRCUT_DATA: FORECAST_API_URLS.RESET_HAIRCUT_DATA,
  FORECAST_RESET_FISCALITY_DATA: FORECAST_API_URLS.RESET_FISCALITY_DATA,
  FORECAST_LATEST_UPLOADED: FORECAST_API_URLS.LATEST_UPLOADED,

  SCENARIO_ANALYSIS_DATA: SCENARIO_ANALYSIS_API_URLS.DATA,
  SCENARIO_ANALYSIS_PREFERENCES_SAVE: SCENARIO_ANALYSIS_API_URLS.PREFERENCES_SAVE,
  SCENARIO_ANALYSIS_PREFERENCES_GET: SCENARIO_ANALYSIS_API_URLS.PREFERENCES_GET,
  AUDIT_LOG_DATA: AUDIT_API_URLS.LOG_DATA,
  AUDIT_GET_AUDIT_DETAIL: AUDIT_API_URLS.GET_AUDIT_DETAIL,
  AUDIT_SAVE_AUDIT_LOG_DATA: AUDIT_API_URLS.SAVE_AUDIT_LOG_DATA,
  // Forecast Workflow APIs
  FORECAST_SEND_FOR_APPROVAL: FORECAST_WORKFLOW_API_URLS.SEND_FOR_APPROVAL,
  FORECAST_APPROVE: FORECAST_WORKFLOW_API_URLS.APPROVE,
  FORECAST_REJECT: FORECAST_WORKFLOW_API_URLS.REJECT,

  // Mapping APIs
  MAPPING_GET_MARKET_MAPPINGS: MAPPING_API_URLS.GET_MARKET_MAPPINGS,
  MAPPING_GET_SUPPLY_CONTRACT_MAPPINGS: MAPPING_API_URLS.GET_SUPPLY_CONTRACT_MAPPINGS,
  MAPPING_GET_DELIVERY_POINT_MAPPINGS: MAPPING_API_URLS.GET_DELIVERY_POINT_MAPPINGS,
  MAPPING_GET_FIELD_MAPPINGS: MAPPING_API_URLS.GET_FIELD_MAPPINGS,
  MAPPING_GET_ENDURE_MAPPINGS: MAPPING_API_URLS.GET_ENDURE_MAPPINGS,
  // POST (create or update)
  MAPPING_POST_MARKET: MAPPING_API_URLS.UPDATE_MARKET_MAPPING,
  MAPPING_POST_SUPPLY_CONTRACT: MAPPING_API_URLS.ADD_UPDATE_SUPPLY_CONTRACT_MAPPING,
  MAPPING_POST_DELIVERY_POINT: MAPPING_API_URLS.ADD_UPDATE_DELIVERY_POINT_MAPPING,
  MAPPING_POST_FIELD: MAPPING_API_URLS.ADD_UPDATE_FIELD_MAPPING,
  MAPPING_POST_ENDURE_MAPPING: MAPPING_API_URLS.ADD_UPDATE_ENDURE_MAPPING,
  // DELETE
  MAPPING_DELETE_DELIVERY_POINT: MAPPING_API_URLS.DELETE_DELIVERY_POINT_MAPPING,
  MAPPING_DELETE_FIELD: MAPPING_API_URLS.DELETE_FIELD_MAPPING,
  MAPPING_DELETE_ENDURE_MAPPING: MAPPING_API_URLS.DELETE_ENDURE_MAPPING,

  // FETCH options for dropdowns in mapping forms
  MAPPING_GET_SUPPLY_CONTRACT_OPTIONS: MAPPING_API_URLS.GET_SUPPLY_CONTRACT_OPTIONS,
  MAPPING_GET_DELIVERY_POINT_OPTIONS: MAPPING_API_URLS.GET_DELIVERY_POINT_OPTIONS,
  MAPPING_GET_FIELD_OPTIONS: MAPPING_API_URLS.GET_FIELD_OPTIONS,
  MAPPING_SAVE_RISK_PROFILE: MAPPING_API_URLS.SAVE_RISK_PROFILE,
  MAPPING_SET_DEFAULT_RISK_PROFILE: MAPPING_API_URLS.SET_DEFAULT_RISK_PROFILE,
  // Royalties APIs
  ROYALTIES_GET_IN_KIND_FISCALITY: ROYALTIES_API_URLS.GET_IN_KIND_FISCALITY,
  ROYALTIES_GET_MAZARA_FLOWS: ROYALTIES_API_URLS.GET_MAZARA_FLOWS,
  ROYALTIES_GET_MAZARA_OSS_DATA: ROYALTIES_API_URLS.GET_MAZARA_OSS_DATA,
  ROYALTIES_GET_MAZARA_VS_OSS: ROYALTIES_API_URLS.GET_MAZARA_VS_OSS,
  INTERTEK_GET_FIELD_ALLOCATION: INTERTEK_API_URLS.GET_FIELD_ALLOCATION,
  INTERTEK_GET_SUPPLIER_BUYER_PROFILE: INTERTEK_API_URLS.GET_SUPPLIER_BUYER_PROFILE,

  RANKING_GET_RANKING: RANKING_API_URLS.GET_RANKING,

  ALLOCATION_GET_ALLOCATION: ALLOCATION_API_URLS.GET_ALLOCATION,
  ALLOCATION_GET_DELIVERY_POINT: ALLOCATION_API_URLS.GET_DELIVERY_POINT,
  ALLOCATION_DOWNLOAD_ALLOCATION: ALLOCATION_API_URLS.DOWNLOAD_ALLOCATION,
  ALLOCATION_UPLOAD_ALLOCATION: ALLOCATION_API_URLS.UPLOAD_ALLOCATION,
  ALLOCATION_GET_ALLOCATION_AUDIT_LOG: ALLOCATION_API_URLS.GET_ALLOCATION_AUDIT_LOG,
  ALLOCATION_GET_ALLOCATION_AUDIT_LOG_DETAILS: ALLOCATION_API_URLS.GET_ALLOCATION_AUDIT_LOG_DETAILS,
};
